import React, { useEffect, useState } from 'react'
import { getBrands, getRecordsNpsById, list } from '../../services/api'
import { connect } from 'react-redux'
import NpsRecords from '../RatingHome'
import { setBrandSettings, setGlobalColors } from '../../store/actions'
import { Loader } from '../../styles/components'
import { useParams } from 'react-router-dom'

function NpsPage({ dispatch }) {
    const { id } = useParams()
    const [npsData, setNpsData] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        try {
            setLoading(true)
            getRecordsNpsById(id).then(async (res) => {
                if (res) {
                    setNpsData(res)
                    await list({
                        datasource: 'appmeupedido_pacotes_tratado',
                        data: { before_filter: { orderGroup: res.package } },
                        type: 'query',
                    }).then(async (data) => {
                        if (data && data?.[0] && data?.[0].hostname) {
                            await getBrands(data[0].hostname).then((res) => {
                                setLoading(false)
                                if (!res) {
                                    return
                                }
                                dispatch(setBrandSettings(res))
                                const colors = {
                                    primary: res.primary_color,
                                    secondary: res.secondary_color,
                                    background_color: res.background_color,
                                }
                                dispatch(setGlobalColors(colors))
                            })
                        } else {
                            setLoading(false)
                        }
                    })
                } else {
                    setLoading(false)
                }
            })
        } catch (error) {
            setLoading(false)
        }
    }, [id])

    if (loading) return <Loader />
    if (!npsData)
        return (
            <div className="flex items-center justify-center w-full">
                NPS não encontrado ou já respondido.
            </div>
        )

    return <NpsRecords npsData={npsData} onBack={() => window.history.back()} />
}

export default connect((state) => ({
    ordersuser: state?.ordersuser,
    dataQuery: state?.dataQuery,
    globalColors: state?.globalColors,
}))(NpsPage)
